module.exports = __webpack_public_path__ + "media/luxury-2026/staging-closing-interior-960-aa3870ca.jpg";